import { render, staticRenderFns } from "./DefectsHistoryDetail.vue?vue&type=template&id=032815f2&scoped=true&"
import script from "./DefectsHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./DefectsHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./DefectsHistoryDetail.vue?vue&type=style&index=0&id=032815f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032815f2",
  null
  
)

export default component.exports